import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DefaultAppPageComponent} from './default-app-page.component';
import {MenuModule} from '../menu/menu.module';
import {ContentModule} from '../../../shared/directives/content.module';
import {PartnerBreadcrumbModule} from '../../../modules/partner/common/api/component/partner-breadcrumb/partner-breadcrumb.module';
import {SelectFilterModule} from '../select-filter/select-filter.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CreateMessageModule} from '../../../modules/message/api/component/create-message/create-message.module';
import {MatIconModule} from '@angular/material/icon';
import {PartnerSearchModule} from '../../../modules/partner/common/api/component/partner-search/partner-search.module';
import {InputTextModule} from '../../../modules/core/component/input-text/input-text.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {LoadingModule} from '../loading/loading.module';
import {
    PartnerSummaryItemModule
} from '../../../modules/partner/common/api/component/partner-summary-item/partner-summary-item.module';


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        MenuModule,
        ContentModule,
        PartnerBreadcrumbModule,
        SelectFilterModule,
        CreateMessageModule,
        MatIconModule,
        PartnerSearchModule,
        InputTextModule,
        MatAutocompleteModule,
        MatToolbarModule,
        MatInputModule,
        LoadingModule,
        PartnerSummaryItemModule,
    ],
    declarations: [
        DefaultAppPageComponent,
    ],
    exports: [
        DefaultAppPageComponent,
        ContentModule,
    ],
})
export class DefaultAppPageModule {}
